import { useSelector } from 'react-redux';
import { NextPage } from 'next';

import Layout from '~/src/features/_layout';
import Videocontrol from '~/src/features/videocontrol';
import { initialProps } from '~/src/helpers/basePageFunc';
import { TState } from '~/src/store';
import { getCurrentCityIn, selectCompanyName } from '~/src/store/selectors/city';

const pageBgColor = '#141924';

const VideocontrolPage: NextPage = () => {
    const { companyName, cityIn } = useSelector((state: TState) => ({
        companyName: selectCompanyName(state),
        cityIn: getCurrentCityIn(state),
    }));

    return (
        <Layout
            title={`Установка видеонаблюдения под ключ для квартиры в ${cityIn} от ${companyName}`}
            description={`Подключите систему видеонаблюдения для квартиры или частного дома в ${cityIn}. ` +
                'Управлять видеокамерами Вы сможете со своего смартфона с помощью приложения «Умный Дом.ру». Подробнее на сайте'}
            withMenu={true}
            withFooter={true}
            withChat={true}
            bgColor={pageBgColor}
        >
            <Videocontrol/>
        </Layout>
    );
};

VideocontrolPage.getInitialProps = async(options) => {
    await initialProps(options, { isNeedAuthData: true });

    return {};
};

export default VideocontrolPage;
